// extracted by mini-css-extract-plugin
export default {"saveButton":"app-core-settings-edge-compute-SettingsEdgeCompute-SettingsEdgeCompute-module__save-button"};